// Create Components
export const updateActiveEditor = (activeEditorComponentNumber) => ({
  type: 'UPDATE_ACTIVE_EDITOR',
  activeEditorComponentNumber
});

export const refreshActiveEditor = () => ({
  type: 'REFRESH_ACTIVE_EDITOR'
});